import React from 'react';
import { useTranslation } from 'react-i18next';

export default function HeroItemCard({ item, lang }) {
  const { t } = useTranslation();

  const name = item[`name_${lang}`] || item.name_pl || item.name_tr || '';
  const desc = item[`desc_${lang}`] || item.desc_pl || '';
  const emoji = item.icon || item.placeholderEmoji || '🌯';
  const color = item.placeholderColor || 'from-amber-900 to-yellow-800';

  return (
    <article
      id={`item-${item.id}`}
      className="
        relative w-full rounded-2xl overflow-hidden
        border-2 border-bistro-gold
        animate-pulseGold animate-fadeInUp
      "
      style={{
        boxShadow: '0 0 30px rgba(212,168,67,0.25), 0 8px 40px rgba(0,0,0,0.6)',
      }}
    >
      {/* Hero Image (tall) */}
      <div className="relative w-full overflow-hidden" style={{ height: '220px' }}>
        {item.imageUrl ? (
          <img src={item.imageUrl} alt={name} className="w-full h-full object-cover" />
        ) : (
          <div className={`w-full h-full bg-gradient-to-br ${color} flex items-center justify-center`}>
            <span
              className="text-8xl opacity-50"
              style={{ filter: 'drop-shadow(0 4px 16px rgba(212,168,67,0.3))' }}
            >
              {emoji}
            </span>
          </div>
        )}

        {/* Gradient overlay bottom */}
        <div className="absolute inset-0 bg-hero-gradient pointer-events-none" />

        {/* 'Most Popular' badge — top left */}
        <div
          className="absolute top-3 left-3 flex items-center gap-1.5 px-3 py-1.5 rounded-full
                     font-sans font-semibold text-xs text-bistro-dark
                     shadow-gold"
          style={{
            background: 'linear-gradient(135deg, #D4A843 0%, #E8B84B 100%)',
            boxShadow: '0 2px 12px rgba(212,168,67,0.5)',
          }}
        >
          <span>⭐</span>
          <span className="tracking-wide uppercase text-[10px]">
            {t('badge.hero')}
          </span>
        </div>
      </div>

      {/* Content area */}
      <div
        className="p-4"
        style={{ background: 'linear-gradient(145deg, #2C2C2C 0%, #242424 100%)' }}
      >
        {/* Gold top accent line */}
        <div className="w-12 h-0.5 bg-bistro-gold rounded-full mb-3 opacity-80" />

        <h2
          className="font-serif font-bold text-bistro-cream leading-tight"
          style={{ fontSize: 'clamp(1.1rem, 5vw, 1.4rem)' }}
        >
          {name}
        </h2>

        {desc && (
          <p className="mt-2 font-sans text-bistro-muted text-sm leading-relaxed line-clamp-3">
            {desc}
          </p>
        )}

        {/* Price row */}
        <div className="mt-4 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <span className="w-1.5 h-1.5 rounded-full bg-bistro-gold inline-block" />
            <span className="text-bistro-muted text-xs font-sans">Istanbul Bistro</span>
          </div>

          <div className="flex items-baseline gap-1">
            <span
              className="font-sans font-extrabold tabular-nums"
              style={{
                fontSize: 'clamp(1.3rem, 5vw, 1.6rem)',
                background: 'linear-gradient(135deg, #D4A843, #E8B84B)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
              }}
            >
              {item.price?.toFixed(2)}
            </span>
            <span className="text-bistro-amber font-sans font-semibold text-sm">
              {t('menu.currency')}
            </span>
          </div>
        </div>
      </div>
    </article>
  );
}
